(() => {
  const root =
    document.getElementById(
      "tea-concierge"
    );

  if (!root) {
    return;
  }

  const endpoint =
    "https://tea-concierge-worker.steepstatetea.workers.dev/chat";

  const launcher =
    root.querySelector(
      ".tea-concierge__launcher"
    );

    const newChatButton =
  root.querySelector(
    ".tea-concierge__new-chat"
  );

  const panel =
    root.querySelector(
      ".tea-concierge__panel"
    );

  const closeButton =
    root.querySelector(
      ".tea-concierge__close"
    );

  const messages =
    root.querySelector(
      ".tea-concierge__messages"
    );

    const initialMessagesHtml =
  messages.innerHTML;

  const form =
    root.querySelector(
      ".tea-concierge__form"
    );

  const input =
    root.querySelector(
      ".tea-concierge__input"
    );

  const sendButton =
    root.querySelector(
      ".tea-concierge__send"
    );

  const status =
    root.querySelector(
      ".tea-concierge__status"
    );

  if (
    !launcher ||
    !panel ||
    !closeButton ||
    !messages ||
    !form ||
    !input ||
    !sendButton ||
    !status
  ) {
    return;
  }

  const language =
    root.dataset.language || "de";

  const currentPage =
    root.dataset.currentPage ||
    window.location.href;

  const productHandle =
  root.dataset.productHandle || "";

  const STORAGE_KEY =
  "steep-state-tea-concierge-history";

let history = [];

try {
  const savedHistory =
    JSON.parse(
      sessionStorage.getItem(
        STORAGE_KEY
      ) || "[]"
    );

  if (Array.isArray(savedHistory)) {
    history =
      savedHistory.slice(-10);
  }
} catch {
  history = [];
}

let isSending = false;

  function openPanel() {
  panel.hidden = false;
  launcher.hidden = true;

  launcher.setAttribute(
    "aria-expanded",
    "true"
  );

  requestAnimationFrame(() => {
    input.focus();
  });
}

  function closePanel() {
  panel.hidden = true;
  launcher.hidden = false;

  launcher.setAttribute(
    "aria-expanded",
    "false"
  );

  launcher.focus();
}

  function scrollToBottom() {
    messages.scrollTop =
      messages.scrollHeight;
  }

 function renderMarkdown(
  element,
  text
) {
  const normalizedText =
    String(text).replace(
      /^>\s?/gm,
      ""
    );

  const pattern =
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)|\*\*([^*]+)\*\*/g;

  let lastIndex = 0;
  let match;

  while (
    (match =
      pattern.exec(
        normalizedText
      )) !== null
  ) {
    if (match.index > lastIndex) {
      element.appendChild(
        document.createTextNode(
          normalizedText.slice(
            lastIndex,
            match.index
          )
        )
      );
    }

    if (
      match[1] &&
      match[2]
    ) {
      const link =
        document.createElement("a");

      link.textContent = match[1];
      link.href = match[2];

      if (
        match[2].startsWith("http://") ||
        match[2].startsWith("https://")
      ) {
        link.target = "_blank";
        link.rel =
          "noopener noreferrer";
      }

      element.appendChild(link);
    } else if (match[3]) {
      const strong =
        document.createElement("strong");

      strong.textContent = match[3];

      element.appendChild(strong);
    }

    lastIndex =
      pattern.lastIndex;
  }

  if (
    lastIndex <
    normalizedText.length
  ) {
    element.appendChild(
      document.createTextNode(
        normalizedText.slice(
          lastIndex
        )
      )
    );
  }
}

  function addMessage(
    role,
    text
  ) {
    const message =
      document.createElement("div");

    message.className =
      `tea-concierge__message tea-concierge__message--${role}`;

    const bubble =
      document.createElement("div");

    bubble.className =
      "tea-concierge__bubble";

    renderMarkdown(
  bubble,
  text
);

    message.appendChild(bubble);
    messages.appendChild(message);

    scrollToBottom();
  }

  function saveHistory() {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(
        history.slice(-10)
      )
    );
  } catch {
    // Storage may be unavailable.
  }
}

function startNewChat() {
  history = [];

  try {
    sessionStorage.removeItem(
      STORAGE_KEY
    );
  } catch {
    // Storage may be unavailable.
  }

  messages.innerHTML =
    initialMessagesHtml;

  status.hidden = true;
  status.textContent = "";

  input.value = "";

  scrollToBottom();
  input.focus();
}

function restoreHistory() {
  for (const item of history) {
    if (
      !item ||
      (
        item.role !== "user" &&
        item.role !== "assistant"
      ) ||
      typeof item.content !== "string"
    ) {
      continue;
    }

    addMessage(
      item.role,
      item.content
    );
  }
}

  function setBusy(busy) {
    isSending = busy;

    input.disabled = busy;
    sendButton.disabled = busy;

    if (newChatButton) {
  newChatButton.disabled = busy;
}

    if (busy) {
      status.textContent =
        language.startsWith("fr")
          ? "Un instant…"
          : language.startsWith("it")
            ? "Un momento…"
            : language.startsWith("en")
              ? "One moment…"
              : "Einen Moment…";

      status.hidden = false;
    } else {
      status.hidden = true;
      status.textContent = "";

      input.disabled = false;
      sendButton.disabled = false;

      input.focus();
    }
  }

  function getErrorMessage() {
    if (language.startsWith("fr")) {
      return "Une erreur est survenue. Veuillez réessayer.";
    }

    if (language.startsWith("it")) {
      return "Si è verificato un errore. Riprovi.";
    }

    if (language.startsWith("en")) {
      return "Something went wrong. Please try again.";
    }

    return "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.";
  }

  async function sendMessage(text) {
    setBusy(true);

    try {
      const response =
        await fetch(
          endpoint,
          {
            method: "POST",

            headers: {
              "Content-Type":
                "application/json"
            },

            body: JSON.stringify({
              message: text,
              language,
              current_page: currentPage,
              product_handle: productHandle,
              history
            })
          }
        );

      const data =
  await response.json();

if (!response.ok) {
  console.error(
    "Tea Concierge request failed",
    {
      status: response.status,
      error:
        data.error || null,
      request_id:
        data.request_id || null
    }
  );

  if (
    response.status === 429 &&
    data.reply
  ) {
    addMessage(
      "assistant",
      data.reply
    );

    return;
  }

  const reference =
    data.request_id
      ? `\n\nRequest ID: ${data.request_id}`
      : "";

  addMessage(
    "assistant",
    `${getErrorMessage()}${reference}`
  );

  return;
}

if (!data.reply) {
  throw new Error(
    "Empty Concierge reply"
  );
}

addMessage(
  "assistant",
  data.reply
);

history.push(
  {
    role: "user",
    content: text
  },
  {
    role: "assistant",
    content: data.reply
  }
);

     saveHistory();

    } catch (error) {
      console.error(
        "Tea Concierge error",
        error
      );

      addMessage(
        "assistant",
        getErrorMessage()
      );
    } finally {
      setBusy(false);
    }
  }

  restoreHistory();

  launcher.addEventListener(
    "click",
    () => {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    }
  );

if (newChatButton) {
  newChatButton.addEventListener(
    "click",
    startNewChat
  );
}

  closeButton.addEventListener(
    "click",
    closePanel
  );

  document.addEventListener(
    "keydown",
    event => {
      if (
        event.key === "Escape" &&
        !panel.hidden
      ) {
        closePanel();
      }
    }
  );

  input.addEventListener(
  "keydown",
  event => {
    if (
      event.key === "Enter" &&
      !event.shiftKey
    ) {
      event.preventDefault();

      if (!isSending) {
        form.requestSubmit();
      }
    }
  }
);

  form.addEventListener(
    "submit",
    event => {
      event.preventDefault();

      if (isSending) {
        return;
      }

      const text =
        input.value.trim();

      if (!text) {
        return;
      }

      addMessage(
        "user",
        text
      );

      input.value = "";

      sendMessage(text);
    }
  );
})();